import React from 'react';
import moment from 'moment';
import * as CONFIG from 'constants/config';
import { connect } from 'react-redux';
import {
  DropDownChonDonViTTXM,
  DropDownChonQuyTrinhGiaiQuyetDon,
  DropDownChonHuongXuLyTheoDon,
  DropDownChonNhomThamQuyenGiaiQuyet
} from 'components/tt-forms';
import { DatePicker, TextArea, DropDownTreeSelectOneElement } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import InPhieu from '../chuyen-vien/InPhieu.jsx';
import { validatable } from 'components/utils';
import { LetterProcessingWorkFlow, DuLieuHeThong, Reception } from 'api';
import { ContainerFileDinhKem } from 'components/upload';
import { msg } from "constants/message";
import { processType } from 'constants/process-type';
import {AutoSuggest} from "modules/auto-complete";
import {ConfirmDialog} from 'modules/dialog';
import { Toastr } from 'modules/toastr';
const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'XU_LY_DON';
var Promise = require('es6-promise').Promise;
// Du lieu huong xu ly
const process = [processType.xuLyDon.processing.ketThuc];

class KhongCoQuyTrinh extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form_HuongXuLy: false,
      popupConfirmHXL: false,
      hasFileChange: false,
      prepareData: {},

      renderContainer: true,

      // get LOAI DON theo them moi hay chinh sua
      requireText: false,
      lblTextArea: 'Ý kiến xử lý',

      donId: this.props.donId,
      loaiDon: this.props.thongTinDon && this.props.thongTinDon.loaiDonId ? this.props.thongTinDon.loaiDonId : '',
      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,
      hanGiaiQuyetChange: false,

      huongXuLy: '',
      thamQuyenGiaiQuyet: '',
      hanGiaiQuyet: '',
      noiDung: '',

      // huongXuLy: THU_LY
      trangThaiTTXM: '',

      // trangThaiTTXM: GIAO_TTXM
      donViThamTraXacMinh: '',
      donViThamTraXacMinhTen: '',
      thoiHanBaoCaoKetQuaTTXM: '',

      phongBanGiaiQuyet: this.props.userInfo.coQuanQuanLyId,

      truongPhongChiDinh: '',
      coQuanTiepNhanTen: '',
      coQuanTiepNhan: null,
      donViNgoaiHeThong: '',
      donViNgoaiHeThongId: '',

      canBoChiDinh: this.props.userInfo.id,

      // Tai lieu
      listTaiLieuVanThu: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataShow: [],
      dataDonViTTXM: [],
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: '',
      ngayRaThongBaoThuLy: '',
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.huongXuLy != prevState.huongXuLy) {

      switch (this.state.huongXuLy) {

        case processType.xuLyDon.huongXuLy.deXuatThuLy:

          this.setState({
            lblTextArea: 'Ý kiến xử lý',
            requireText: false,
          })
          return;
        case processType.xuLyDon.huongXuLy.luuDonVaTheoDoi:

          this.setState({
            lblTextArea: 'Lý do lưu đơn',
            requireText: true,
          })
          return;
        case processType.xuLyDon.huongXuLy.khongXuLyNeuLyDo:
          this.setState({
            lblTextArea: 'Lý do',
            requireText: true,
          })
          return;
        default:
          this.setState({
            lblTextArea: 'Ý kiến xử lý',
            requireText: false,
          })
          return;
      }
    }
  }

  componentWillMount() {
    this.checkState();
    this.getListDocument();
  }

  // Add component Util
  getListDocument() {

    let dataShow = this.props.listTaiLieuVanThu.filter((item) => {
      return item.donId != this.state.donId
    })

    this.setState({
      dataShow: dataShow
    })
  }

  checkState() {

    let numberState = 0;
    let onlyState = '';

    process.map((item, i) => {
      if (this.props.getState(this.props.listNextStates, item)) {

        onlyState = item;
        numberState++;

        switch (item) {

          case processType.xuLyDon.processing.ketThuc:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_HuongXuLy: true
            });
            break;
        }
      }
    });
  }

  componentDidMount() {
    if (this.state.donId != 0) {
      this.getThongTinXuLy(this.state.donId);
      this.onlyOneState();
    } else {
      this.getThoiHanGQDonMacDinh();
      this.getThoiHanTTXMMacDinh();
      this.onlyOneState();
    }
    this.getDonViTTXM();

  }

  getDonViTTXM() {
    let params={
      loaiDon: this.state.loaiDon ? this.state.loaiDon : null
    }
    DuLieuHeThong.actions.getDonViTTXMNew.request('',params).then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDonViTTXM: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  onlyOneState() {
    if (this.state.numberState == 1) {
      let newState = {
        ...this.state,
        nextState: this.state.onlyState,
        hideDropdown: true,
      }

      this.setState({
        ...newState
      }, this.trigger(newState, true));
    }
  }

  getThoiHanGQDonMacDinh() {
    let params = {
      type: this.props.loaiDonGiaTri ? this.props.loaiDonGiaTri : this.state.loaiDon
    }
    if ((params.type == 'DON_KHIEU_NAI' || params.type == 'DON_TO_CAO' || params.type == 'DON_KIEN_NGHI_PHAN_ANH') && this.state.ngayRaThongBaoThuLy) {
      params.ngayRaThongBaoGiaiQuyet = moment(this.state.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, params).then(res => {
      this.setState({
        hanGiaiQuyet: new Date(res.data)
      },() => {
        let newState = {
          ...this.state
        }
        this.trigger(newState, true)
      })
    })
  }

  getThoiHanTTXMMacDinh() {
    DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, {type: this.props.loaiDonGiaTri ? this.props.loaiDonGiaTri : this.state.loaiDon}).then(res => {
      let thoiHanXuLyMacDinh = moment(res.data).format('DD/MM/YYYY');
      this.setState({
        thoiHanBaoCaoKetQuaTTXM: thoiHanXuLyMacDinh
      }, () => {
        this.trigger(this.state, false);
      })
    })
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.thongTinDon && nextProps.thongTinDon.loaiDonId && this.state.loaiDon != nextProps.thongTinDon.loaiDonId) {
      this.setState({
        loaiDon: nextProps.thongTinDon.loaiDonId
      }, () => {
        this.checkFileHuongXuLy();
        this.getThoiHanGQDonMacDinh();
        this.getThoiHanTTXMMacDinh();
        this.getDonViTTXM();
      })
    }
    if (this.props.loaiDonGiaTri != nextProps.loaiDonGiaTri) {
      this.setState({
        huongXuLy: ''
      })
    }
  }

  getThongTinXuLy(donId) {
    LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(res => {

      this.setState({
        loaiDon: this.props.loaiDonGiaTri
      })

      if (res.data) {
        let info = res.data.thongTinXuLyInfo;
        // Xac dinh co luu du lieu hay chua
        if (info.hanGiaiQuyet == null) {
          this.getThoiHanGQDonMacDinh();

        }
        if ( info.thoiHanBaoCaoKetQuaTTXM == null) {
          this.getThoiHanTTXMMacDinh();
        }
        if (info.nextState == null) {
          this.getThoiHanGQDonMacDinh();
          this.getThoiHanTTXMMacDinh();
          this.trigger(this.state, true);
        } else {

          let newState = {
            ...this.state,
            noiDung: info.yKienXuLy,
            huongXuLy: info.huongXuLy ? info.huongXuLy.giaTri : '',
            thamQuyenGiaiQuyet: info.thamQuyenGiaiQuyet.id,
            phongBanGiaiQuyet: info.phongBanGiaiQuyet ? info.phongBanGiaiQuyet.id : '',
            coQuanTiepNhan: info.coQuanTiepNhan ? info.coQuanTiepNhan.id : null,
            coQuanTiepNhanTen: info.coQuanTiepNhan ? info.coQuanTiepNhan.ten : '',
            nextState: info.nextState ? info.nextState.type : '',
            truongPhongChiDinh: info.canBoXuLyChiDinh ? info.canBoXuLyChiDinh.id : '',
            trangThaiTTXM: ((info.huongXuLy && info.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.deXuatThuLy) && info.mapTrangThaiTTXM) ? info.mapTrangThaiTTXM.enum : '',
            hanGiaiQuyet: ((info.huongXuLy && info.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.deXuatThuLy) && info.hanGiaiQuyet) ? moment(info.hanGiaiQuyet).format('DD/MM/YYYY') : '',
            donViThamTraXacMinh: ((info.huongXuLy && info.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.deXuatThuLy) && info.donViThamTraXacMinh && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM') ? info.donViThamTraXacMinh.id : '',
            donViThamTraXacMinhTen: ((info.huongXuLy && info.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.deXuatThuLy) && info.donViThamTraXacMinh && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM') ? info.donViThamTraXacMinh.ten : '',
            thoiHanBaoCaoKetQuaTTXM: ((info.huongXuLy && info.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.deXuatThuLy) && info.thoiHanBaoCaoKetQuaTTXM && info.mapTrangThaiTTXM.enum == 'GIAO_TTXM') ? moment(info.thoiHanBaoCaoKetQuaTTXM).format('DD/MM/YYYY') : '',
            donViNgoaiHeThong: info.donViNgoaiHeThong ? info.donViNgoaiHeThong.ten : '',
            donViNgoaiHeThongId: info.donViNgoaiHeThong ? info.donViNgoaiHeThong.id : '',
          }

          this.setState({
            ...newState
          }, () => {
            this.checkFileHuongXuLy();
          });

          this.trigger(newState, true);
        }
      }
    })
  }

  handleChange(name, e) {
    let newState = {
      ...this.state,
      [name]: e.target.value
    }

    let index = (name === 'coQuanTiepNhan') ? 0 : e.nativeEvent.target.selectedIndex;

    if (name === 'huongXuLy') {
      if (e.target.value === 'DE_XUAT_THU_LY') {
        if (this.state.dataDonViTTXM.length == 0) {
          newState = {
            ...newState,
            noiDung: '',
            thamQuyenGiaiQuyet: 1,
            truongPhongChiDinh: '',
            trangThaiTTXM: 'TU_TTXM'
          }
        } else {
          newState = {
            ...newState,
            noiDung: '',
            thamQuyenGiaiQuyet: 1,
            truongPhongChiDinh: '',
            trangThaiTTXM: ''
          }
        }
      } else {
        newState = {
          ...newState,
          noiDung: '',
          thamQuyenGiaiQuyet: '',
          truongPhongChiDinh: '',
          trangThaiTTXM: ''
        }
      }
      if (this.state.hasFileChange) {
        this.state.prepareData = newState;
        this.state.popupConfirmHXL = true;
        this.setState({...this.state});
        return;
      }
    }

    if (name =='hanGiaiQuyet') {
      this.setState({
        hanGiaiQuyetChange: true
      })
    }

    if (name == 'donViThamTraXacMinh') {
      newState = {
        ...newState,
        donViThamTraXacMinhTen: e.nativeEvent.target[index].text
      }
    }

    if (name == 'phongBanGiaiQuyet') {
      newState = {
        ...newState,
        truongPhongChiDinh: '',
        dataTaiLieuVanThuDelete: this.state.dataTaiLieuVanThuDelete,
      }
    }

    if (name == 'coQuanTiepNhan') {
      newState = {
        ...newState,
        coQuanTiepNhanTen: '',
        dataTaiLieuVanThuDelete: this.state.dataTaiLieuVanThuDelete,
      }
      this.props.coQuanTiepNhanList.map((item) => {
        if (item.coQuanQuanLyId == e.target.value) {
          newState.coQuanTiepNhanTen = item.ten;
        }
      });
    }

    this.setState({
      ...newState
    }, () => {
      if (name == 'huongXuLy') {
        this.checkFileHuongXuLy();
      }
      if (name == 'trangThaiTTXM') {
        this.checkFileTTXM()
      }
      this.trigger(newState, false);
    });
  }

  confirmChangeHuongXuLy(next) {
    if (next) {
      this.setState({
        ...this.state.prepareData,
        hasFileChange: false
      }, () => {
        this.checkFileHuongXuLy();
        this.trigger(this.state.prepareData, false);
      });
    } else {
      this.state.popupConfirmHXL = false;
      this.setState({...this.state});
    }
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime();

    if (firstTime > secondTime || type == 'show') {
      return true
    } else {
      return false
    }
  }

  checkFileHuongXuLy() {
    this.setState({
      renderContainer: false
    },()=>{
      let DataInit = [...this.props.listTaiLieuVanThu];
      let dataFileDinhKem = [];
      let dataShow = [];
      if (this.props.ngayTraTTXMKhongDungThamQuyen) {
        dataFileDinhKem = DataInit.filter(state => {
          return this.compareDate(new Date(state.ngayTao), new Date(this.props.ngayTraTTXMKhongDungThamQuyen), 'action');
        })
        dataShow = DataInit.filter(state => {
          return this.compareDate(new Date(this.props.ngayTraTTXMKhongDungThamQuyen), new Date(state.ngayTao), 'show');
        })
        this.setState({
          dataShow: [...dataShow]
        })
      } else if (this.props.ngayNhanDon) {
        dataFileDinhKem = DataInit.filter(state => {
          return this.compareDate(new Date(state.ngayTao), new Date(this.props.ngayNhanDon), 'action');
        })
        dataShow = DataInit.filter(state => {
          return this.compareDate(new Date(this.props.ngayNhanDon), new Date(state.ngayTao), 'show');
        })
        this.setState({
          dataShow: [...dataShow]
        })
      } else {
        dataFileDinhKem = DataInit.filter((item) => {
          return item.donId == this.state.donId
        });
      }

      let typeRequired = '';
      let name = ''
      if (this.state.huongXuLy == 'DE_XUAT_THU_LY') {
        let data = [...dataFileDinhKem];
        let dataExist = data.filter(item => {
          return item.typeRequired == 'XLD_PDXTL'
        });

        if (dataExist.length > 0) {
          let listTaiLieuVanThu = [
            ...dataFileDinhKem
          ];
          let dataFilter = listTaiLieuVanThu.filter(item => {
            return (item.newFile && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && !item.typeRequired)
          })
          this.setState({
            listTaiLieuVanThu: dataFilter,
            ngayRaThongBaoThuLy: dataExist[0].ngayQuyetDinh ? new Date(dataExist[0].ngayQuyetDinh) : ''
          },()=> {
            this.trigger(this.state, false);
            this.setState({
              renderContainer: true
            },()=> {
              this.checkFileTTXM();
            })
          })
        } else if (this.state.loaiDon == 'DON_KHIEU_NAI' || this.state.loaiDon == 'DON_TO_CAO'){
          let ItemDTTL = {
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'XLD_PDXTL',
            newFile: true
          }
          if (this.state.loaiDon == 'DON_TO_CAO') {
            ItemDTTL.ten = 'Thông báo về việc thụ lý giải quyết tố cáo';
          } else if (this.state.loaiDon == 'DON_KHIEU_NAI') {
            ItemDTTL.ten = 'Thông báo về việc thụ lý giải quyết khiếu nại';
          }
          let listTaiLieuVanThu = [
            ...dataFileDinhKem,
            ItemDTTL
          ];
          let dataFilter = listTaiLieuVanThu.filter(item => {
            return (item.newFile && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && !item.typeRequired)
          })

          this.setState({
            listTaiLieuVanThu: dataFilter
          }, () => {
            this.setState({
              renderContainer: true
            },()=> {
              this.checkFileTTXM();
            })
          })
        } else {
          let ItemTL = {
            ten: 'Phiếu đề xuất thụ lý',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: false,
            typeRequired: 'XLD_PDXTL',
            newFile: true,
            resetRequired: true,
            checkValid: true
          }
          let listTaiLieuVanThu = [
            // ...dataFileDinhKem,
            ItemTL
          ];
          let dataFilter = listTaiLieuVanThu.filter(item => {
            return (item.newFile && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && !item.typeRequired)
          })

          this.setState({
            listTaiLieuVanThu: dataFilter
          }, () => {
            this.setState({
              renderContainer: true
            },()=> {
              this.checkFileTTXM();
            })
          })
        }
      } else if (
        (this.state.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY' && (this.state.loaiDon == 'DON_KHIEU_NAI' || this.state.loaiDon == 'DON_TO_CAO' || this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH'))
        || (this.state.huongXuLy == 'CHUYEN_DON')
        || (this.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN' && (this.state.loaiDon == 'DON_TO_CAO' || this.state.loaiDon == 'DON_KHIEU_NAI'))
        || (this.state.huongXuLy == 'HUONG_DAN_VIET_LAI_DON' && this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH')
        || (this.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN' && (this.state.loaiDon == 'DON_TO_CAO' || this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH'))
        || (this.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON' && this.props.loaiDonGiaTri == 'DON_KHIEU_NAI')
        ){
        if (this.state.huongXuLy == 'KHONG_DU_DIEU_KIEN_THU_LY') {
          typeRequired = 'XLD_KDDKTL';
          if (this.state.loaiDon == 'DON_TO_CAO') {
            name = 'Thông báo về việc không thụ lý giải quyết tố cáo'
          } else if (this.state.loaiDon == 'DON_KHIEU_NAI') {
            name = 'Thông báo về việc khiếu nại không đủ điều kiện thụ lý giải quyết '
          } else if (this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH'){
            name = 'Thông báo về việc không xử lý giải quyết kiến nghị, phản ánh'
          }
        } else if (this.state.huongXuLy == 'CHUYEN_DON') {
          typeRequired = 'XLD_CD';
          if (this.state.loaiDon == 'DON_TO_CAO') {
            name = 'Văn bản về việc chuyển đơn tố cáo'
          } else if (this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH'){
            name = 'Văn bản về việc chuyển đơn kiến nghị, phản ánh'
          } else {
            name = 'Văn bản chuyển đơn'
          }
        } else if (this.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN') {
          typeRequired = 'XLD_TDHD';
          if (this.state.loaiDon == 'DON_TO_CAO') {
            name = 'Văn bản về việc hướng dẫn người tố cáo'
          } else if (this.state.loaiDon == 'DON_KHIEU_NAI') {
            name = 'Văn bản về việc hướng dẫn người khiếu nại'
          }
        } else if (this.state.huongXuLy == 'HUONG_DAN_VIET_LAI_DON') {
          typeRequired = 'XLD_TDHD';
          if (this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
            name = 'Hướng dẫn đơn có nhiều nội dung khác nhau thuộc nhiều cơ quan có thẩm quyền giải quyết'
          }
        } else if (this.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN') {
          typeRequired = 'XLD_TDKDTQ';
          name = 'Văn bản về việc trả lại đơn chuyển không đúng thẩm quyền';
        } else if (this.state.huongXuLy == 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON') {
          typeRequired = 'XLD_TDKDTQLD';
          name = 'Văn bản trả lại đơn chuyển không đúng thẩm quyền';
        }
        let data = [...dataFileDinhKem];
        let dataExist = data.filter(item => {
          return item.required && item.typeRequired == typeRequired
        });
        if (dataExist.length > 0 && this.state.huongXuLy !== 'CHUYEN_DON') {
          let listTaiLieuVanThu = [
            ...dataFileDinhKem
          ];
          let dataFilter = listTaiLieuVanThu.filter(item => {
            return (item.newFile && item.typeRequired == typeRequired) || (!item.newFile && item.typeRequired == typeRequired) || (!item.newFile && !item.typeRequired)
          })
          this.setState({
            listTaiLieuVanThu: dataFilter
          },()=> {
            this.setState({
              renderContainer: true
            },()=> {
              this.checkFileTTXM();
            })
          })
        } else {
          let newItem = {
            ten: name,
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: typeRequired,
            newFile: true
          }
          let listTaiLieuVanThu = [
            ...dataFileDinhKem,
            newItem
          ];
          let dataFilter = [];
          if (this.state.huongXuLy === 'CHUYEN_DON') {
            dataFilter = [
              newItem
            ];
          } else {
            dataFilter = listTaiLieuVanThu.filter(item => {
              return (item.newFile && item.typeRequired == typeRequired) || (!item.newFile && item.typeRequired == typeRequired) || (!item.newFile && !item.typeRequired)
            })
          }
          this.setState({
            listTaiLieuVanThu: dataFilter
          }, () => {
            this.setState({
              renderContainer: true
            })
          })
        }
      } else {
        let listTaiLieuVanThu = [
          ...dataFileDinhKem
        ];
        let dataFilter = listTaiLieuVanThu.filter(item => {
          return !item.newFile && (item.typeRequired == '' || item.typeRequired == null)
        })
        this.setState({
          listTaiLieuVanThu: dataFilter
        }, () => {
          this.setState({
            renderContainer: true
          })
        })
      }
    })

  }

  checkFileTTXM() {
    this.setState({
      renderContainer: false
    },()=> {
      let dataFileDinhKem = this.props.listTaiLieuVanThu.filter((item) => {
        return item.donId == this.state.donId
      });
      if (this.state.trangThaiTTXM == 'GIAO_TTXM' && (this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO' || this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH')) {
        let data = [...dataFileDinhKem];
        let dataExist = data.filter(item => {
          return item.required && item.typeRequired == 'XLD_GTTXM'
        });

        if (dataExist.length > 0) {
          let listTaiLieuVanThu = [
            ...dataFileDinhKem
          ];
          let dataFilter = listTaiLieuVanThu.filter(item => {
            return (item.newFile && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && item.typeRequired == 'XLD_PDXTL') || (!item.newFile && !item.typeRequired) || (!item.newFile && item.typeRequired == 'XLD_GTTXM')
          })
          this.setState({
            listTaiLieuVanThu: dataFilter
          },()=> {
            this.setState({
              renderContainer: true
            })
          })
        } else {
          let newItem = {
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'XLD_GTTXM',
            newFile: true
          }
          if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {
            newItem.ten = 'Quyết định về việc thụ lý giải quyết tố cáo và giao nhiệm vụ xác minh nội dung tố cáo'
          } else if (this.state.loaiDonGiaTri == 'DON_KHIEU_NAI') {
            newItem.ten = 'Quyết định về việc giao nhiệm vụ xác minh nội dung khiếu nại'
          } else if (this.state.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
            newItem.ten = 'Văn bản về việc giao nhiệm vụ xác minh nội dung kiến nghị, phản ánh'
          }
          let listTaiLieuVanThu = [
            ...this.state.listTaiLieuVanThu,
            newItem
          ];
          let newPDXItem = this.state.dataFileDinhKem.filter(item => {
            return item.typeRequired == 'XLD_PDXTL'
          });
          if (newPDXItem.length) {
            listTaiLieuVanThu = listTaiLieuVanThu.map(item => {
              return (item.typeRequired == 'XLD_PDXTL') ? newPDXItem[0] : item;
            });
          }
          this.setState({
            listTaiLieuVanThu: listTaiLieuVanThu
          }, () => {
            this.setState({
              renderContainer: true
            })
          })
        }
      } else {
        let listTaiLieuVanThu = [
          ...this.state.listTaiLieuVanThu
        ];
        let dataFilter = listTaiLieuVanThu.filter(item => {
          return item.typeRequired != 'XLD_GTTXM'
        })
        this.setState({
          listTaiLieuVanThu: dataFilter
        }, () => {
          this.setState({
            renderContainer: true
          })
        })
      }
    })

  }

  checkHanGiaiQuyet() {
    let params = {
      loaiDon: this.state.loaiDon
    }
    if ((this.state.loaiDon == 'DON_TO_CAO' || this.state.loaiDon == 'DON_KHIEU_NAI') && this.state.ngayRaThongBaoThuLy) {
      params.ngayBatDau = moment(this.state.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      if (this.state.hanGiaiQuyet) {
        params.ngayKetThuc = moment(this.state.hanGiaiQuyet, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
    }
    DuLieuHeThong.actions.checkHanGiaiQuyet.request(null, params).then().catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail,'error');
      }
    })
  }

  handleChangeDate(name, e) {
    let newState = {
      ...this.state,
      [name]: e
    }
    if (typeof e.format == 'function') {
      newState = {
        ...this.state,
        [name]: e.format(CONFIG.DateFormat)
      }
    }

    this.setState({
      ...newState
    }, () => {
      if (name == 'ngayRaThongBaoThuLy') {
        let newFileArr = [...this.state.listTaiLieuVanThu];
        newFileArr = newFileArr.map(item => {
          if (item.typeRequired == 'XLD_PDXTL') {
            return item = {
              ...item,
              ngayQuyetDinh: this.state.ngayRaThongBaoThuLy
            };
          } else {
            return item;
          }
        });
        this.setState({
          loaiVanBanSuggest: 'XLD_PDXTL',
          ngayQuyetDinhSuggest: this.state.ngayRaThongBaoThuLy,
          listTaiLieuVanThu: newFileArr
        });
        this.getThoiHanGQDonMacDinh();
      }

      if (name == 'hanGiaiQuyet') {
        this.checkHanGiaiQuyet();
      }
      this.trigger(newState, false);
    });
  }

  trigger(newState, isInit) {

    let stateId = this.props.getState(this.props.listNextStates, newState.nextState);
    let thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
    let params = {
      yKienXuLy: newState.noiDung,
      nextState: {
        id: Number(stateId)
      }
    }

    params.huongXuLy = newState.huongXuLy || null;

    if (newState.thamQuyenGiaiQuyet &&
      newState.huongXuLy != processType.xuLyDon.huongXuLy.yeuCauGapLanhDao &&
      newState.huongXuLy != processType.xuLyDon.huongXuLy.luuDonVaTheoDoi)

      params.thamQuyenGiaiQuyet = {
        id: Number(newState.thamQuyenGiaiQuyet)
      }

    if (newState.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy) {

      params.notice = msg.xldChuyenGiaiQuyetDon;

      if ((this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO') && newState.ngayRaThongBaoThuLy) {
        params.ngayRaThongBaoThuLy = moment(newState.ngayRaThongBaoThuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      if (this.state.hanGiaiQuyetChange) {
        params.hanGiaiQuyet = moment(newState.hanGiaiQuyet, 'DD/MM/YYYY').add(7, 'hours');
      } else {
        params.hanGiaiQuyet = moment(newState.hanGiaiQuyet, 'DD/MM/YYYY');
      }
      params.trangThaiTTXM = newState.trangThaiTTXM || null;

      if (newState.trangThaiTTXM == "TU_TTXM") {

        if (newState.phongBanGiaiQuyet)
          params.phongBanGiaiQuyet = { id: Number(newState.phongBanGiaiQuyet) };
        let userInfo=  localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

        params.canBoXuLyChiDinh = { id: Number(userInfo.id) };

      } else if (newState.trangThaiTTXM == "GIAO_TTXM") {

        if (newState.donViThamTraXacMinh) {

          params.donViThamTraXacMinh = { id: Number(newState.donViThamTraXacMinh) };
          params.donViThamTraXacMinhTen = newState.donViThamTraXacMinhTen;
        }

        if (newState.thoiHanBaoCaoKetQuaTTXM)
          params.thoiHanBaoCaoKetQuaTTXM = moment(newState.thoiHanBaoCaoKetQuaTTXM, 'DD/MM/YYYY');
      }
    } else if (newState.huongXuLy == processType.xuLyDon.huongXuLy.chuyenDon) {

      if (newState.thamQuyenGiaiQuyet == thamQuyenHanhChinhId) {
        params.notice = msg.xldChuyenDon;
        params.coQuanTiepNhan = {
          id: Number(newState.coQuanTiepNhan),
          ten: newState.coQuanTiepNhanTen
        };
      } else {
        params.notice = msg.xldLuuHoSo;
        params.donViNgoaiHeThong = newState.donViNgoaiHeThong;
        params.donViNgoaiHeThongId = newState.donViNgoaiHeThongId;
      }
    } else if (newState.huongXuLy == processType.xuLyDon.huongXuLy.yeuCauGapLanhDao) {

      params.notice = msg.xldYeuCauGapLanhDao;
    } else if (newState.huongXuLy == processType.xuLyDon.huongXuLy.traDonChuyenKhongDungThamQuyen) {

      params.notice = msg.xldTraDon;

    } else if (newState.huongXuLy != processType.xuLyDon.huongXuLy.deXuatThuLy &&
      newState.huongXuLy != processType.xuLyDon.huongXuLy.chuyenDon &&
      newState.huongXuLy != processType.xuLyDon.huongXuLy.yeuCauGapLanhDao) {

      params.notice = msg.xldLuuHoSo;
    }

    this.props.onChange(params, isInit);

  }

  onFileRemove(id, data) {

    let temp = {
      dataFileDinhKem: data,
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    }

    this.setState({
      ...temp
    });



    this.props.onChangeTepDinhKem(temp.dataFileDinhKem, temp.dataTaiLieuVanThuDelete, loaiQuyTrinh, loaiTepDinhKem);
  }

  onFileChange(data) {
    let tbtlDate = data.filter(item => {
      return item.typeRequired == 'XLD_PDXTL';
    });
    if (tbtlDate.length) {
      this.state.ngayRaThongBaoThuLy = tbtlDate[0].ngayQuyetDinh;
      this.getThoiHanGQDonMacDinh();
    }
    this.setState({
      dataFileDinhKem: data
    });

    this.props.onChangeTepDinhKem(data, this.state.dataTaiLieuVanThuDelete, loaiQuyTrinh, loaiTepDinhKem);
  }

  searchDonVi(tuKhoa){
    let inputParams = {
      size: 5,
      page: 0
    }

    inputParams.ten = tuKhoa;

    return Reception.actions.getDonViNgoaiHeThong.request('', inputParams).then(res => {
      if (res.data && res.data._embedded) {
        return Promise.resolve({
          result: res.data._embedded.donViNgoaiHeThongs,
          page: res.data.page
        })
      } else {
        return Promise.resolve(null);
      }
    }).catch(err => {
      return Promise.reject(err);
    });
  }

  onChangeSuggest(name, value) {
    this.state[name] = value;
    this.state.donViNgoaiHeThongId = '';
    this.setState({...this.state});
    this.trigger(this.state, false);
  }

  onSelectedSuggest(item) {
    this.state.donViNgoaiHeThong = item.ten;
    this.state.donViNgoaiHeThongId = item.donViNgoaiHeThongId;
    this.setState({...this.state});
    this.trigger(this.state, false);
  }

  render() {
    let thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
    return (
      <div className="items-form">
        <ConfirmDialog title={msg.confirmChange} open={this.state.popupConfirmHXL} onClose={this.confirmChangeHuongXuLy.bind(this, false)} onSuccess={this.confirmChangeHuongXuLy.bind(this, true)}/>
        <div className="row pl10 pr10">
            <DropDownChonHuongXuLyTheoDon require
              selectedValue={this.state.huongXuLy}
              donId={this.props.donId}
              loaiDon={this.props.loaiDonGiaTri}
              label="Hướng xử lý"
              onChange={this.handleChange.bind(this, 'huongXuLy')}
              className="col-3"
              bindValidator={this}
              name="dropdownChonHuongXuLyTheoDon" />
            <ShowIf condition={this.state.huongXuLy !== 'YEU_CAU_GAP_LANH_DAO' && this.state.huongXuLy !== 'LUU_DON_VA_THEO_DOI' && this.state.huongXuLy !== 'TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON'}>
              <DropDownChonNhomThamQuyenGiaiQuyet require
                selectedValue={this.state.thamQuyenGiaiQuyet}
                checkValidate = {this.props.checkValidate}
                filterThamQuyenGiaiQuyet={this.state.huongXuLy === 'CHUYEN_DON'}
                label="Nhóm thẩm quyền giải quyết"
                className="col-3"
                onChange={this.handleChange.bind(this, 'thamQuyenGiaiQuyet')}
                bindValidator={this}
                name="dropdownChonNhomThamQuyenGiaiQuyet" />
            </ShowIf>
            <ShowIf condition={this.state.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy}>
              <ShowIf condition={this.props.loaiDonGiaTri == 'DON_KHIEU_NAI' || this.props.loaiDonGiaTri == 'DON_TO_CAO'}>
                <DatePicker require
                  className="col-25"
                  checkValidate = {this.props.checkValidate}
                  value={this.state.ngayRaThongBaoThuLy}
                  label='Ngày ra thông báo thụ lý'
                  name="ngayRaThongBaoThuLy"
                  onChange={this.handleChangeDate.bind(this, 'ngayRaThongBaoThuLy')}
                  bindValidator={this}
                  channel='formTaoDon'/>
              </ShowIf>
              <DatePicker require
                className="col-25"
                value={this.state.hanGiaiQuyet}
                label='Hạn giải quyết'
                name="hanGiaiQuyet"
                startDate={moment(new Date()).subtract(1, "days")}
                onChange={this.handleChangeDate.bind(this, 'hanGiaiQuyet')}
                bindValidator={this}
                channel="formTaoDon" />
            </ShowIf>
            <ShowIf condition={this.state.huongXuLy == 'CHUYEN_DON' &&  this.state.thamQuyenGiaiQuyet == thamQuyenHanhChinhId}>
              <DropDownTreeSelectOneElement label="Cơ quan tiếp nhận" className='tree-selected' placeholder dataOptions={this.props.coQuanTiepNhanList} value={this.state.coQuanTiepNhan} onChange={this.handleChange.bind(this, 'coQuanTiepNhan')} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId' name="dropdownChonCoQuanTiepNhan" bindValidator={this} channel="formTaoDon" require/>
            </ShowIf>
            {
              this.state.thamQuyenGiaiQuyet && this.state.thamQuyenGiaiQuyet != thamQuyenHanhChinhId && this.state.huongXuLy == 'CHUYEN_DON' ?
                <AutoSuggest
                  label="Đơn vị"
                  className="col-3"
                  placeholder="Nhập..."
                  onSearch={this.searchDonVi}
                  onChange={this.onChangeSuggest.bind(this, 'donViNgoaiHeThong')}
                  onSelected={this.onSelectedSuggest.bind(this)}
                  value={this.state.donViNgoaiHeThong}
                  maxLength={40}
                />
              : ''
            }
        </div>
        <ShowIf condition={this.state.huongXuLy == processType.xuLyDon.huongXuLy.deXuatThuLy && this.state.dataDonViTTXM.length > 0}>
            <div className="row pl10 pr10">
              <DropDownChonQuyTrinhGiaiQuyetDon
                className="col-25"
                donId={this.props.donId}
                bindValidator={this}
                require
                loaiDon={this.props.loaiDonGiaTri}
                isValid={this.props.validate}
                selectedValue={this.state.trangThaiTTXM}
                onChange={this.handleChange.bind(this, 'trangThaiTTXM')}
                name="dropdownChonTrangThaiTTXM" />
              <ShowIf condition={this.state.trangThaiTTXM == 'GIAO_TTXM'}>
                <DropDownChonDonViTTXM
                  className="col-25"
                  bindValidator={this}
                  require
                  loaiDon={this.props.loaiDonGiaTri}
                  isValid={this.props.validate}
                  selectedValue={this.state.donViThamTraXacMinh}
                  onChange={this.handleChange.bind(this, 'donViThamTraXacMinh')}
                  name="dropdownChonDonViTTXM" />
                <div className="col-25">
                  <label className="pt-label">
                    <span className="val-title mb0">Thời gian báo cáo kết quả:</span>
                    <span className="val-content pt17 txt-danger">{this.state.thoiHanBaoCaoKetQuaTTXM}</span>
                  </label>
                </div>
              </ShowIf>
            </div>
          </ShowIf>
          <div className="row pl10 pr10">

            <TextArea
              require={this.state.requireText}
              label={this.state.lblTextArea}
              rows="3"
              value={this.state.noiDung ? this.state.noiDung : ''}
              onChange={this.handleChange.bind(this, 'noiDung')}
              bindValidator={this}
              channel="formTaoDon"
              name="textareaYKienCanBoXuLyDon" />
          </div>
          <ShowIf condition={this.props.action === undefined || (this.props.action === "them-moi" && this.state.huongXuLy !== "TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN_LUU_DON")}>
            <div className="row pl10 pr10">
              <InPhieu inPhieu={this.props.inPhieu.bind(this)}
                huongXuLy={this.state.huongXuLy}
                loaiDonGiaTri={this.state.loaiDon}
                trangThaiTTXM={this.state.trangThaiTTXM || null} />
            </div>
          </ShowIf>
          <ShowIf condition={this.state.renderContainer}>
            <div className="container-filedinhkem mt15">
              <ContainerFileDinhKem label="Danh sách văn bản xử lý"
                checkValidate = {this.props.checkValidate}
                bindValidator={this}
                data={this.state.listTaiLieuVanThu}
                dataShow={this.state.dataShow}
                onSave={this.props.onSave}
                loaiVanBanSuggest={this.state.loaiVanBanSuggest}
                ngayQuyetDinhSuggest={this.state.ngayQuyetDinhSuggest}
                onFileRemove={this.onFileRemove.bind(this)}
                onFileChange={this.onFileChange.bind(this)}
              />
            </div>
          </ShowIf>
      </div>
    );
  }
}

KhongCoQuyTrinh.defaultProps = {
  listNextStates: [],
  tongSoLuotTCD: 0,
  validate: false,
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  getState: function () {
    console.log('Need to assign getState method');
  },
  onSave: false,
}

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    coQuanTiepNhanList: state.duLieuHeThong.coQuanTiepNhan
  }
}

export default connect(bindStateToProps)(validatable(KhongCoQuyTrinh));



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-xu-ly/khong-co-quy-trinh/KhongCoQuyTrinh.jsx